import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Injector } from '@angular/core'
import { ChooseFlightData } from 'src/app/flight/models/ChooseFlightData';
import { FlightsFormData } from 'src/app/flight/models/FlightsFormData';
import { Confirmation } from 'src/app/flight/models/Confirmation';
import { getItemFromSessionStorage, getInstanceFromSessionStorage, FLIGHT_FORM_DATA, CHOOSE_FLIGHT_DATA, removeItensFromSessionStorage, GOOGLE_USER, CREW_INFO } from 'src/app/utils/SessionStorageUtil';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { FlightSegment, NewTicketRequest } from '../models/NewTicketRequest';
import { PasseLivreService } from 'src/app/core/services/passe-livre/passe-livre.service';
import { NewTicketResponse } from '../models/NewTicketResponse';
import { DialogInfoComponent } from 'src/app/shared/components/dialog-info/dialog-info.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { finalize } from 'rxjs/operators';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { PasseLivreExternalCrewService } from 'src/app/core/services/passe-livre/passe-livre-external-crew.service';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { PasseLivreLatamCrewService } from 'src/app/core/services/passe-livre/passe-livre-latam-crew.service';
import { RouterPasseLivre } from 'src/app/core/services/router/router';
import { RouterExternalCrewService } from 'src/app/core/services/router/router-external-crew.service';
import { RouterLatamCrewService } from 'src/app/core/services/router/router-latam-crew.service';
import { HomeComponent } from 'src/app/pages/home/home.component';
import { GoogleUser } from 'src/app/models/GoogleUser';
import { GoogleAuthenticationService } from 'src/app/core/services/login/google-authentication.service';
import { FlightSegmentSch, OTAAirScheduleResponse, OriginDestinationOption } from '../models/OTAAirScheduleResponse';

@Component({
    selector: 'app-flight-confirmation',
    templateUrl: './flight-confirmation.component.html',
    styleUrls: ['./flight-confirmation.component.scss'],
    standalone: false
})
export class FlightConfirmationComponent implements OnInit {

  private passeLivreService: PasseLivreService;
  private routerService: RouterPasseLivre;
  // TODO: componente undefined
  private homeComponente: HomeComponent;

  constructor(public dialog: MatDialog,
    private passeLivreServiceTwo: PasseLivreLatamCrewService,
    private googleAuthenticationService: GoogleAuthenticationService,
    public notificationService: NotificationService,
    private injector: Injector,
    private crewInfoStore: CrewInfoStore,
    private authorizationService: AuthorizationService) {

    if (this.authorizationService.isExternal()) {
      this.passeLivreService = <PasseLivreExternalCrewService>this.injector.get(PasseLivreExternalCrewService);
      this.routerService = <RouterExternalCrewService>this.injector.get(RouterExternalCrewService);
    } else {
      this.passeLivreService = <PasseLivreLatamCrewService>this.injector.get(PasseLivreLatamCrewService);
      this.routerService = <RouterLatamCrewService>this.injector.get(RouterLatamCrewService);
    }
  }

  @ViewChild('loading') templateLoadingRef: TemplateRef<any>;
  dialogLoadingRef: MatDialogRef<any>;

  confirmation: Confirmation = new Confirmation();

  ngOnInit(): void {

    this.init();

  }

  async init() {
    let crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);
    const flightFormData = getItemFromSessionStorage<FlightsFormData>(FLIGHT_FORM_DATA);
    const chooseFlightData = getInstanceFromSessionStorage(CHOOSE_FLIGHT_DATA, ChooseFlightData);

    if (crewInfo == null) {
      await this.getCrewInfo();
      crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);
    }

    this.confirmation.flightOption = flightFormData ? flightFormData.option : this.confirmation.flightOption;
    this.confirmation.crewName = crewInfo ? crewInfo.firstName : this.confirmation.crewName;
    this.confirmation.outbound = chooseFlightData ? chooseFlightData.outbound : this.confirmation.outbound;
    this.confirmation.inbound = chooseFlightData ? chooseFlightData.inbound : this.confirmation.inbound;
  }

  back(): void {
    this.routerService.goHome({ tab: 1 });
  }

  async getCrewInfo() {
    return new Promise<boolean>((resolve) => {
      const googleUser: GoogleUser | null = this.googleAuthenticationService.getGoogleUser();

      if (googleUser?.email) {
        this.passeLivreServiceTwo.getLatamCrew().subscribe({
          next: (crewInfo: CrewInfo) => {
            this.crewInfoStore.setCrewInfo(crewInfo);
            resolve(true);
          },
          error: () => {
            this.notificationService.error('Ocorreu um erro ao buscar os dados do tripulante.');
            resolve(false);
          }
        });
      }
    })
  }

  addSecondsToDateTime(dateTime: string): string {
    return dateTime.length === 16 ? dateTime + ':00' : dateTime;
}

  async confirmReservation() {
    let crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);
    if (crewInfo == null) {
      await this.getCrewInfo();
      crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);
    }

    const newTicketRequest: NewTicketRequest = this.createNewTicketRequest(crewInfo);
    
    if (newTicketRequest.outboundFlight && newTicketRequest.outboundFlight.length > 0) {
      newTicketRequest.outboundFlight.forEach(flight => {
          flight.departureDateTime = this.addSecondsToDateTime(flight.departureDateTime);
          flight.arrivalDateTime = this.addSecondsToDateTime(flight.arrivalDateTime);
      });
  }
  

  if (newTicketRequest.inboundFlight && newTicketRequest.inboundFlight.length > 0) {
      newTicketRequest.inboundFlight.forEach(flight => {
          flight.departureDateTime = this.addSecondsToDateTime(flight.departureDateTime);
          flight.arrivalDateTime = this.addSecondsToDateTime(flight.arrivalDateTime);
      });
  }
  

    this.startLoading();

    this.passeLivreService.newTicket(newTicketRequest)
      .pipe(finalize(() => this.stopLoading()))
      .subscribe({
        next: (newTicketResponse: NewTicketResponse) => {
          if (newTicketResponse.success) {
            removeItensFromSessionStorage([FLIGHT_FORM_DATA, CHOOSE_FLIGHT_DATA]);
            this.routerService.goHome({ refresh: true });
            this.notificationService.success('Reserva realizada com sucesso!');
          } else {
            this.showErrors(newTicketResponse.errors);
          }
        },
        error: () => {
          this.notificationService.error('Houve um erro inesperado na confirmação da reserva!');
        }
      });
  }

  private startLoading(): void {
    this.dialogLoadingRef = this.dialog.open(this.templateLoadingRef, {
      width: '300px',
      disableClose: true,
      id: 'loading'
    });
  }

  private stopLoading(): void {
    this.dialogLoadingRef.close();
  }

  private createNewTicketRequest(crewInfo: CrewInfo | null): NewTicketRequest {
    const newTicketRequest = new NewTicketRequest();

    if (this.authorizationService.isExternal()) {
      console.log('crewInfo', crewInfo);
      newTicketRequest.code = crewInfo?.code?.value;
      newTicketRequest.email = crewInfo?.email;
    }
    newTicketRequest.crewCompany = crewInfo?.company ? crewInfo?.company : 'JJ';
    newTicketRequest.outboundFlight = this.createFlightSegment(this.confirmation.outbound);

    if (this.confirmation.isRoundTrip() && this.confirmation.inbound) {
      newTicketRequest.inboundFlight = this.createFlightSegment(this.confirmation.inbound);
    }

    return newTicketRequest;
  }

  private createFlightSegment(flight: OriginDestinationOption): FlightSegment[] {

    let flightSegmentList: FlightSegment[] = [];
    
    flight.flightSegments.forEach((segment: FlightSegmentSch) => {
      const flightSegment: FlightSegment = new FlightSegment();
      flightSegment.airlineCode = segment.operator;
      flightSegment.departureAirport = segment.originLocationCode;
      flightSegment.arrivalAirport = segment.destinationLocationCode;
      flightSegment.departureDateTime = segment.departureDateTime;
      flightSegment.arrivalDateTime = segment.arrivalDateTime;
      flightSegment.flightNumber = segment.flightNumber;
      flightSegmentList.push(flightSegment)
    });


    return flightSegmentList;

  }

  private showErrors(errors: string[]): void {
    const html: string = `
      <ul class="error-message">
        ${errors.map(error => `<li>${error}</li>`).join('')}
      </ul>
    `;

    this.dialog.open(DialogInfoComponent, {
      width: '600px',
      data: { title: 'Ocorreu um erro!', html: html }
    });
  }
}
